const DASHBOARD_GOTO_UPLOAD = 'dashboardGotoUpload'
const DASHBOARD_START_REVIEWING = 'dashboardStartReviewing'
const UPDATED_VISIT = 'updatedVisit'
const ADDED_NEW_VISIT = 'addedNewVisit'
const SUCCESS = 'Success'
const FAILURE = 'Failure'
const VIEW_TAGS_REPORT = 'viewTagsReport'
const VIEW_TEXT_REPORT = 'viewTextReport'
const EDIT_CLIENT = 'editClient'
const IMAGE_UPLOAD_TABLE = 'imageUploadTable'
const PROGRAM_SUMMARY = 'programSummary'
const TIME_FRAME_CHANGE = 'timeFrameChange'
const DATE_RANGE_CHANGED = 'dateRangeChanged'
const EXPORTED_CSV = 'exportedCSV'
const START = 'Start'
const TOGGLED_VIEW = 'toggledView'
const GRAPH = 'graph'
const TABLE = 'table'
const CHANGED_TEST_STATE = 'changedTestState'
const ADD_NEW_VISIT = 'addNewVisit'
const FILTER = 'filter'
const SEARCH = 'search'
const $SESSION_END = '$session_end'
const $SESSION_START = '$session_start'
const DASHBOARD = 'dashboard'
const VIEW_CLIENT_LIST = 'viewClientList'
const CLIENT_SELECTED = 'clientSelected'
const ADD_NEW_CLIENT = 'addNewClient'
const MANAGE_UPLOADS = 'manageUploads'
const MANAGE_USERS = 'manageUsers'
const MANAGE_SITES = 'manageSites'
const VIEW_RADIOLOGIST_FEEDBACK = 'viewRadiologistFeedback'
const VIEW_LAB_CONFIRMATIONS = 'viewLabConfirmations'
const CLIENT_REGISTERED = 'clientRegistered'
const ALLOWED_LOCATION_ACCESS = 'allowedLocationAccess'
const DENIED_LOCATION_ACCESS = 'deniedLocationAccess'
const IMAGE_UPLOAD = 'imageUpload'
const VIEW_CLIENT_SUMMARY = 'viewClientSummary'
const ADD_CLIENT_CONTINUE = 'addClientContinue'
const ADD_CLIENT_TRY_AGAIN = 'addClientTryAgain'
const FULL_REPORT_DOWNLOAD = 'fullReportDownload'
const FULL_REPORT_REQUEST = 'fullReportRequest'
const VIEW_SUMMARY = 'viewSummary'
const UPLOAD = 'upload'
const VIEW_RESULTS = 'viewResults'
const DICOM_UPLOADS = 'dicomUploads'
const FEEDBACK_SUBMITTED = 'feedbackSubmitted'
const FEEDBACK_SUBMIT_FAILURE = 'feedbackSubmitFailure'
const IMAGE_UPLOAD_CLIENT_SUMMARY = 'imageUploadClientSummary'
const QXR_REPORT = 'qXRReport'
const QXR_REPORT_DOWNLOAD = 'qXRReportDownload'
const OPEN_XRAY = 'openXRay'
const CLIENT_SUMMARY = 'clientSummary'
const VIEW_XRAY = 'viewXray'
const SAVE_EDITED_REPORT = 'saveEditedReport'
const WATCH_HELP_VIDEO = 'clickedVideoLink'

export default {
  DASHBOARD_GOTO_UPLOAD,
  DASHBOARD_START_REVIEWING,
  UPDATED_VISIT,
  ADDED_NEW_VISIT,
  SUCCESS,
  FAILURE,
  VIEW_TAGS_REPORT,
  VIEW_TEXT_REPORT,
  EDIT_CLIENT,
  IMAGE_UPLOAD_TABLE,
  PROGRAM_SUMMARY,
  TIME_FRAME_CHANGE,
  DATE_RANGE_CHANGED,
  EXPORTED_CSV,
  START,
  TOGGLED_VIEW,
  GRAPH,
  TABLE,
  CHANGED_TEST_STATE,
  ADD_NEW_VISIT,
  FILTER,
  SEARCH,
  $SESSION_END,
  DASHBOARD,
  VIEW_CLIENT_LIST,
  ADD_NEW_CLIENT,
  MANAGE_UPLOADS,
  MANAGE_USERS,
  MANAGE_SITES,
  VIEW_RADIOLOGIST_FEEDBACK,
  VIEW_LAB_CONFIRMATIONS,
  CLIENT_REGISTERED,
  ALLOWED_LOCATION_ACCESS,
  DENIED_LOCATION_ACCESS,
  IMAGE_UPLOAD,
  VIEW_CLIENT_SUMMARY,
  ADD_CLIENT_CONTINUE,
  ADD_CLIENT_TRY_AGAIN,
  $SESSION_START,
  FULL_REPORT_DOWNLOAD,
  FULL_REPORT_REQUEST,
  VIEW_SUMMARY,
  UPLOAD,
  VIEW_RESULTS,
  DICOM_UPLOADS,
  FEEDBACK_SUBMITTED,
  FEEDBACK_SUBMIT_FAILURE,
  IMAGE_UPLOAD_CLIENT_SUMMARY,
  QXR_REPORT,
  QXR_REPORT_DOWNLOAD,
  OPEN_XRAY,
  CLIENT_SELECTED,
  CLIENT_SUMMARY,
  VIEW_XRAY,
  SAVE_EDITED_REPORT,
  WATCH_HELP_VIDEO
}
